import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { Alert, Button, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import SearchComponent from '../../_Components/SearchComponent';
import RenderProfilePicture from '../../../../../../_helpers/profile-picture';
import { usersService } from '../../../../../../_services/users.service';
import { alertActions } from '../../../../../../_actions/alert.actions';
import httpStatus from 'http-status';

export default function AddToTeam({ user, handleBack }) {
  const dispatch = useDispatch();

  const [data, setData] = useState()
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)
  const [addingToTeam, setAddingToTeam] = useState(false)
  
  const [searchTerm, setSearchTerm] = useState(false)
  
  const [selected, setSelection] = useState([])

  useEffect(() => {
    performSearch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm])

  const columns = [
    {
      name: 'LICENSED USER',
      sort: false,
      cell: row => {
        let fullName = `${row.firstName} ${row.lastName}`

        if (row.credentials) {
          fullName = `${fullName}, ${row.credentials}`
        }

        return <div className='row w-100'>
        <div className="col-auto">
          <RenderProfilePicture height={30} width={30} image={row.profileUrl} circle cached={false} className='m-auto' />
        </div>
        <div className="col-auto">
          <div className="row">
            <div className="col">
              <div>{fullName}</div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span className='text-muted'>{row.specialtyTitle}</span>
            </div>
          </div>
        </div>
      </div>
      }
    },
  ];

  const performSearch = (page = 1) => {
    setLoading(true)

    usersService.getOptionsLicensed(page, searchTerm)
      .then(results => {
        setData(results.data);
        setTotal(results.meta.total)
      })
      .catch(() => {
        dispatch(alertActions.error('We could not retrieve your licensed users at this time. Please try again.'))
      })
      .then(() => {
        setLoading(false)
      })
  }
  
  const addText = selected.length === 1 ? 'Add to Team' : 'Add to Teams';

  const handleAddToTeam = () => {
    setAddingToTeam(true)

    usersService.addToLicensedTeam(user, selected)
      .then(() => {
        dispatch(alertActions.success('Licensed team added successfully!'));
        handleBack(true)
      })
      .catch(error => {
        if (error.response && error.response.status === httpStatus.UNPROCESSABLE_ENTITY) {
          dispatch(alertActions.error(error.response.data.message));
        } else {
          dispatch(alertActions.error('Could not add to licensed team at this time. Please try again.'));
        }
      })
      .then(() => {
        setAddingToTeam(false)
      })
  }

  function EmptyResults() {
    if (searchTerm) {
      return <div style={{ padding: '24px' }}>There are no licensed users to display</div>
    }

    return <div className="p-5 text-center"> 
      <h5 className="mb-4">{`Before assigning ${user.firstName} ${user.lastName} to a Licensed Team, you must add a Licensed User`}</h5>
      <Link to={{pathname: '/account/users/add', state: {userType: 'Licensed'}}} className="btn btn-primary">Add Licensed User</Link>
    </div>
  }

  return <>
    <div className='lead pb-3'>Add To Licensed Team</div>

    <Alert variant="primary">
      <p className="mb-0">
        Select the licensed team you would like to add the user to.
      </p>
    </Alert>
    <div className="axs-shadow axs-rounded p-1 mb-3" style={{background: 'white'}}>
      <DataTable
        noHeader
        data={data}
        columns={columns}
        disabled={addingToTeam}
        progressPending={loading}
        selectableRows
        onSelectedRowsChange={selection => { setSelection(selection.selectedRows.map(row => row.licensedId)) }}
        subHeader
        subHeaderComponent={
          <SearchComponent disabled={addingToTeam} placeholder='Search Licensed User' handleSearch={search => setSearchTerm(search)}>
            <div className="form-group">
              <div className='d-flex'>
                <Button disabled={addingToTeam} onClick={() => handleBack(false)} className='mr-4 px-4' variant='outline-primary'>Cancel</Button>
                
                { selected.length > 0 &&
                  <Button disabled={addingToTeam} onClick={handleAddToTeam} className='px-5' variant='success'>
                  { addingToTeam ? <Spinner size='sm' animation='border'/> : addText}
                  </Button>
                }
              </div>
            </div>
          </SearchComponent>
        }
        onChangePage={page => performSearch(page) }
        pagination={!addingToTeam}
        paginationServer={true}
        paginationTotalRows={total}
        paginationRowsPerPageOptions={[15]}
        paginationPerPage={15}
        noDataComponent={<EmptyResults />}
        customStyles={{ 
          cells: { style: { fontSize: '14px', padding: '1.5em' }, }, 
          headCells: { style: { fontWeight: 400, color: 'RGB(161, 165, 183)', padding: '1.5em'}, }, 
          subHeader: { style: { justifyContent: 'space-between', padding: '10px 10px 0 10px' } }
        }}
      />
    </div>
  </>
}
